<template>
    <painel titulo="Publicar Edital" icon="pi pi-check" :mostrarRefresh="false">
        <div class="formgrid grid p-fluid">
            <label class="field col-12 md:col-12 required">Anexos</label>
            <div class="flex field col-12">
                <FileUpload
                    ref="fileUpload"
                    :multiple="true"
                    :customUpload="true"
                    @uploader="arquivoSelecionado"
                    mode="basic"
                    chooseLabel="Anexar Documentos"
                    :auto="true"
                />
            </div>
        </div>
        <div class="mt-2 mb-2" v-for="(anexo, index) in anexos" :key="index">
            <strong>{{ anexo.name }}</strong>
            <i class="pi pi-trash p-error icon-button ml-2" style="font-size: 1.2rem" @click="limparArquivo(index)"></i>
        </div>
        <div class="field mt-5">
            <btn-voltar
                class="ml-0"
                :route="{
                    name: `Licitacoes_Solicitacoes_Detalhar`,
                }"
            ></btn-voltar>
            <Button @click="confirmarAprovacao" :disabled="anexos.length === 0" class="ml-3">Publicar Edital</Button>
        </div>
    </painel>
</template>

<script>
import StatusFaseService from '../services';

export default {
    data() {
        return {
            anexos: [],
        };
    },
    emits: ['voltar'],
    methods: {
        arquivoSelecionado(event) {
            for (let file of event.files) {
                this.anexos.push(file);
            }
            this.$refs.fileUpload.clear();
        },
        limparArquivo(index) {
            this.anexos.splice(index, 1);
        },
        confirmarAprovacao() {
            this.$confirm.require({
                message: `Tem certeza que deseja publicar o edital?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.publicarEdital();
                },
            });
        },
        publicarEdital() {
            this.$store.dispatch('addRequest');

            const formData = new FormData();
            this.anexos.forEach((file) => {
                formData.append('anexos', file);
            });

            formData.append('SolicitacaoId', this.$route.params.id);
            formData.append('StatusPublicacao', 'aprovado');
            formData.append('TipoReprovacao', '');
            formData.append('TipoAjuste', '');

            StatusFaseService.publicacaoEdital(formData).then((response) => {
                if (response && response.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Publicação do Edital',
                        detail: 'O edital foi publicado com sucesso',
                        life: 3000,
                    });
                    this.$store.dispatch('setAtualizar', true);
                    this.$emit('voltar');
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Publicação do Edital',
                        detail: 'Erro ao publicar edital',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },
};
</script>
